import type {
  LegacyShareFeedbackStudent,
  MeetingMyStudentsOverview,
} from "meetings/student-meeting/types";

/**
 * Adapts a student-meeting overview to the legacy snake_case shape expected by
 * the shared `components/modals/share/ShareAllFeedback.vue` drawer ("Alles
 * delen"). Students without ratings are excluded — the drawer only shares
 * feedback for students that have at least one rating.
 *
 * Shared by the my-students, mentor-class and lesson-class "Leerlingbespreking"
 * pages, which all feed the same drawer.
 */
export const overviewToShareFeedbackStudents = (
  overview: MeetingMyStudentsOverview | null,
): LegacyShareFeedbackStudent[] => {
  if (overview === null) {
    return [];
  }

  const { meeting } = overview;

  return overview.students
    .filter((student) => student.ratings.length > 0)
    .map((student) => ({
      id: student.id,
      first_name: student.firstName,
      middle_name: student.middleName,
      last_name: student.lastName,
      report: {
        invite: student.report.invite ? 1 : 0,
        feedback_sent: student.report.feedbackSent ? 1 : 0,
        feedback_seen: student.report.feedbackSeen ? 1 : 0,
      },
      ratings: [
        {
          meeting: {
            id: meeting.id,
            name: meeting.name,
            mail_student: meeting.mailStudent,
            share_feedback_at: meeting.shareFeedbackAt,
          },
        },
      ],
    }));
};
